<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title class="ma-auto" center>
              Select Dashboard
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col
                cols="12" sm="6" md="6" lg="6"
                v-for="board in boards"
                :key="board.name"
              >
                <router-link :to="{ name: 'dashboard', params: { type: board.type } }">
                  <v-btn color="primary w-100">{{ board.name }}</v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <logout></logout>
  </v-container>
</template>

<script>
import Logout from "@/views/Logout";

const testLayout = [
  { x: 0, y: 0, w: 2, h: 2, i: "0" },
  { x: 2, y: 0, w: 2, h: 2, i: "1" },
  { x: 0, y: 2, w: 4, h: 2, i: "2" },
];
import { mapGetters } from "vuex";
import auth from '@/mixins/auth';

export default {
  name: "Home",
  mixins: [auth],
  components: {
    // GridLayout: VueGridLayout.GridLayout,
    // GridItem: VueGridLayout.GridItem
    logout: Logout,
  },
  data: () => ({
    layout: testLayout,
  }),
  computed: {
    boards() {
      let boards = this.getBoards();

      return boards;
    },
  },
  mounted() {
    this.getBoards();
    this.streams();
  },
  methods: {
    ...mapGetters(["getBoards", "streams"]),
    logout: function () {
      this.$store.dispatch("app/authLogout").then(() => {
        this.$router.push("/login");
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.block {
  &__background {
    &.yellow {
      background: yellow;
    }

    &.green {
      background: yellow;
    }

    &.red {
      background: red;
    }
  }
}

.w-100 {
  width: 100%;
}
</style>
